<template>
  <section class="entry-root">
    <entry-list />
    <div class="entry-root-messages" v-if="currentProject">
      <messages-root
        v-if="currentProjectForm"
        :project="currentProject"
        :endpoint="currentProjectForm"
      />
      <div class="entry-root__empty" v-else-if="currentProject">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          clip-rule="evenodd"
          viewBox="0 0 24 24"
        >
          <path
            d="M2.978 8.358l-2.978-2.618 8.707-4.74 3.341 2.345 3.21-2.345 8.742 4.639-3.014 2.68.014.008 3 4.115-3 1.634v4.122l-9 4.802-9-4.802v-4.115l1 .544v2.971l7.501 4.002v-7.889l-2.501 3.634-9-4.893 2.978-4.094zm9.523 5.366v7.875l7.499-4.001v-2.977l-5 2.724-2.499-3.621zm-11.022-1.606l7.208 3.918 1.847-2.684-7.231-3.742-1.824 2.508zm11.989 1.247l1.844 2.671 7.208-3.927-1.822-2.498-7.23 3.754zm-9.477-4.525l8.01-4.43 7.999 4.437-7.971 4.153-8.038-4.16zm-2.256-2.906l2.106 1.851 7.16-3.953-2.361-1.657-6.905 3.759zm11.273-2.052l7.076 3.901 2.176-1.935-6.918-3.671-2.334 1.705z"
          />
        </svg>
        <div class="display-7 text-muted">Nothing to show</div>
      </div>
    </div>
    <project-settings-popup
      v-if="currentProject && editProjectPopup"
      :project="currentProject"
      @close="editProjectPopup = false"
    />
  </section>
</template>

<script>
import {
  setRouterParams,
  getRouterParams
} from '../../../services/local-router'

import EntryList from './entry-list.vue'
import MessagesRoot from '../messages/messages-root.vue'
import ProjectSettingsPopup from '../projects/project-settings-popup.vue'

export default {
  components: { MessagesRoot, EntryList, ProjectSettingsPopup },
  name: 'entry-root',
  data() {
    return {
      editProjectPopup: false
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject
    },
    currentProjectForm() {
      return this.$store.getters.currentProjectForm
    }
  },
  async created() {
    const { project, form } = getRouterParams()
    if (project) {
      this.$store.commit('setCurrentProjectId', parseInt(project))
    }
    if (form) {
      this.$store.commit('setCurrentProjectFormId', parseInt(form))
    }

    await this.$store.dispatch('fetchProjects')

    this.$root.$on('update-projects', async () => {
      await this.$store.dispatch('fetchProjects')
    })
    this.$root.$on('edit-project-popup', (state) => {
      this.editProjectPopup = state
    })
  },
  methods: {
    updateRoute() {
      setRouterParams({
        project: this.currentProject ? this.currentProject.id : '',
        form: this.currentProjectForm ? this.currentProjectForm.id : ''
      })
    }
  },
  watch: {
    currentProject() {
      this.updateRoute()
    },
    currentProjectForm() {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss">
.entry-root {
  display: grid;
  grid-template-columns: 320px 1fr;
  height: calc(100vh - 70px);
  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-align: center;
    user-select: none;
    svg {
      width: 200px;
      height: auto;
      path {
        fill: $gray-300;
      }
    }
  }
  .messages {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background: $white;

    .messages-list {
      flex-grow: 1;
      min-height: unset;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 2px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba($primary, 0.75);
      }
    }
    .pagination {
      margin-top: auto;
    }
  }
}

.entry-root-messages {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  background-color: $white;
}
</style>
